<!--
    Width is set by the dialog config, NOT here. An inner min-width wider than
    (dialog width - the surface's 2 x 24px padding) is what put a horizontal scrollbar
    along the bottom of the first version.
-->
<div class="w-full">
    <h2 mat-dialog-title class="!text-xl !mb-0">Is this a pack price?</h2>

    <div mat-dialog-content class="!pt-2 !pb-0">
        <p class="text-secondary text-sm">
            @if (data.partNumber) { {{ data.partNumber }} &middot; }
            you entered <span class="font-medium">{{ data.enteredCost | currency: "GBP" }}</span>
        </p>

        <!-- Label INSIDE the checkbox: that is what makes the text clickable and
             vertically aligned. A sibling <mat-label> is unstyled and inert. -->
        <mat-checkbox class="mt-4 -ml-2" color="primary" [(ngModel)]="isPack">
            This cost is for a pack, not a single unit
        </mat-checkbox>

        @if (isPack) {
        <mat-form-field class="w-full fuse-mat-dense mt-3" [subscriptSizing]="'dynamic'">
            <mat-label>Units per pack</mat-label>
            <input matInput type="number" min="2" step="1" [(ngModel)]="packQuantity" placeholder="e.g. 250" />
        </mat-form-field>
        }

        <!-- The working out, shown ONLY when a division actually happened. Four decimals on a
             single unit is just noise dressed up as precision. -->
        <!-- Colours pinned explicitly rather than via .text-secondary. In the first version the
             same class rendered grey on the subtitle but ORANGE inside this tinted box, so
             something in the cascade reaches it here that does not reach the line above. -->
        @if (isPack && canConfirm) {
        <div class="mt-4 rounded-lg bg-blue-50 px-4 py-3 dark:bg-gray-800">
            <div class="flex items-baseline justify-between gap-4">
                <span class="text-sm text-gray-600 dark:text-gray-300">Unit cost</span>
                <span class="text-2xl font-medium text-gray-900 dark:text-gray-50">£{{ unitCost.toFixed(4) }}</span>
            </div>
            <div class="mt-1 text-sm text-gray-600 dark:text-gray-300">
                {{ data.enteredCost | currency: "GBP" }} &divide; {{ packQuantity }} units
            </div>
        </div>
        } @else if (isPack) {
        <p class="text-secondary mt-4 text-sm">Enter how many units are in the pack.</p>
        } @else {
        <p class="text-secondary mt-4 text-sm">
            Saved as a unit cost of {{ data.enteredCost | currency: "GBP" }}.
        </p>
        }
    </div>

    <div mat-dialog-actions class="flex justify-end gap-3 !pb-0">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="confirm()" [disabled]="!canConfirm">
            Confirm
        </button>
    </div>
</div>
